<template>
  <div>
    <div id="ag-grid-demo">
      <vx-card>
        <div class="flex flex-wrap justify-between items-center form-title">
          <h4 class="">Users</h4>
          <div class="flex flex-wrap justify-end items-center">
            <div class="flex flex-wrap ag-grid-table-actions-right">
              <span class="w-full sm:w-auto">
                <vs-input
                  class="mb-4 md:mb-0 mr-4  w-full sm:w-auto"
                  v-model="searchQuery"
                  @input="updateSearchQuery"
                  placeholder="Search..."
                />
              </span>
              <span class="w-full sm:w-auto">
                <vx-tooltip text="Export Excel">
                  <a
                    :href="
                      excelurl +
                        `/v2/users/excel/download?organization_id=${organization_id}&token=${temp_token}`
                    "
                    target="_blank"
                    v-if="this.archive != 'archive'"
                  >
                    <vs-button
                      v-if="
                        permissionPageAccessArry.includes(
                          PermissionVariables.UserExport
                        ) || loginUserRole == 'Admin'
                      "
                      class="px-4 w-full sm:w-auto"
                    >
                      <span class="d-inline-flex pr-5 text-white">Export</span>
                      <img
                        src="@/assets/images/icons/export-excel.svg"
                        class="d-inline-flex"
                        height="20"
                        width="20"
                      />
                    </vs-button>
                  </a>
                </vx-tooltip>
              </span>
              <span class="w-full sm:w-auto">
                <vx-tooltip text="Export Archive Excel">
                  <a
                    :href="
                      excelurl +
                        `/v2/users/excel/download?organization_id=${organization_id}&token=${temp_token}&archive=1&search=${searchQuery}`
                    "
                    target="_blank"
                    v-if="this.archive == 'archive'"
                  >
                    <vs-button class="px-4">
                      <span class="d-inline-flex pr-5 text-white">Export</span>

                      <img
                        src="@/assets/images/icons/export-excel.svg"
                        class="d-inline-flex"
                        height="20"
                        width="20"
                      />
                    </vs-button>
                  </a>
                </vx-tooltip>
              </span>
            </div>
          </div>
        </div>
        <ag-grid-vue
          :gridOptions="gridOptions"
          class="ag-theme-material w-100 my-4 ag-grid-table"
          :columnDefs="columnDefs"
          :defaultColDef="defaultColDef"
          :rowData="users"
          rowSelection="multiple"
          :animateRows="true"
          :floatingFilter="false"
          :paginationPageSize="paginationPageSize"
          :pagination="true"
          :suppressPaginationPanel="true"
        />
        <vs-pagination
          :total="totalPages"
          :max="maxPageNumbers"
          v-model="currentPage"
        />
      </vx-card>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import UserService from "@/services/UserService.js";
import userStatus from "./userStatus";
import SearchService from "@/services/searchService.js";
import editUser from "./editUser.vue";
import userAgreement from "./userAgreement.vue";
import userDetails from "./userDetails.vue";
import { BASEURL } from "@/config/index.js";
import PermissionVariables from "@/services/UserManagementVaraibles.js";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
export default {
  components: {
    AgGridVue,
  },
  props: ["listType"],
  data() {
    return {
      permissionPageAccessArry: window.localStorage.getItem(
        "permissionPageAccess"
      )
        ? localStorage.getItem("permissionPageAccess").split(",")
        : "",
      PermissionVariables: PermissionVariables,
      loginUserRole: window.localStorage.getItem("UserRole"),
      tempToken: window.localStorage.getItem("TempToken"),
      excelurl: BASEURL,
      organization_id: "",
      totalPages: 0,
      archive: this.listType,
      users: [],
      searchQuery: "",
      gridOptions: {},
      maxPageNumbers: 7,
      gridApi: null,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: [],
    };
  },
  watch: {
    "$store.state.windowWidth"(val) {
      if (val <= 576) {
        this.maxPageNumbers = 4;
        this.gridOptions.columnApi.setColumnPinned("email", null);
      } else this.gridOptions.columnApi.setColumnPinned("email", "left");
    },
  },
  computed: {
    UserRole() {
      return window.localStorage.getItem("UserRole");
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 100;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        if (val) {
          this.getUserList(val);
          return val;
        } else return 1;
      },
    },
  },
  methods: {
    updateSearchQuery(val) {
      SearchService.getAllSerchResultV2(val, "users", null)
        .then((response) => {
          const { data } = response;
          if (data.data.length > 0 && data.Status) {
            this.users = data.data;
          } else {
            this.users = [];
          }
        })
        .catch((error) => {
          this.$vs.notify({
            title: "Data Not Found",
            text: error.Message,
            iconPack: "feather",
            icon: "check_box",
            color: "warning",
          });
        });
    },
    getUserList: function(currentPage) {
      let filter = {
        page: currentPage,
        contracy_active: 1,
      };
      if (this.archive == "archive") {
        filter["archive"] = true;
      }
      UserService.UserList(filter)
        .then((response) => {
          const { data } = response;

          if (data.err || data.Status == false) {
          } else {
            this.users = data.data;
            this.totalPages = data.pagination.last_page;
            this.gridApi.sizeColumnsToFit();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  beforeMount() {
    this.organization_id = localStorage.getItem("OrganizationID");
    eventBus.$on("refreshuserTable", (e) => {
      this.getUserList(this.currentPage);
    });
  },

  mounted() {
    this.columnDefs = [
      {
        headerName: "Image",
        field: "user_pic",
        width: 100,
        sortable: false,
        suppressSizeToFit: true,
        cellRenderer: function(params) {
          if (params.value && params.value.length > 0) {
            return `<img  class="img-rounded" src=${params.value +
              "?token=" +
              window.localStorage.getItem("TempToken")} />`;
          } else {
            return `<img  class="img-rounded" src="https://api.gokozo.com/uploads/8e834a837c03cb52_org.png"/>`;
          }
        },
      },
      {
        headerName: "Name",
        field: "user_name",
        width: 200,
      },
      {
        headerName: "Email",
        field: "user_email",
        width: 275,
      },
      {
        headerName: "User Status",
        field: "",
        width: 150,
        hide: localStorage.getItem("UserType") == 2 ? false : true,
        cellRenderer: function(params) {
          if (
            params.data.employment_active > 0 &&
            params.data.contract_active > 0
          ) {
            return "Both User";
          } else if (params.data.employment_active > 0) {
            return "Normal User";
          } else if (params.data.contract_active > 0) {
            return "Contract User";
          }
        },
      },
      {
        headerName: "Agreement",
        field: "user_id",
        width: 100,
        sortable: false,
        suppressToolPanel: true,
        cellStyle: { "text-align": "center" },
        cellRendererFramework: userAgreement,
      },
      {
        headerName: "Details",
        field: "user_id",
        width: 100,
        sortable: false,
        suppressToolPanel: true,
        cellStyle: { "text-align": "center" },
        cellRendererFramework: userDetails,
      },

      {
        headerName: "Edit",
        field: "",
        width: 95,
        sortable: false,
        hide:
          (this.archive == "archive" ||
            !this.permissionPageAccessArry.includes(
              PermissionVariables.UserEdit
            )) &&
          this.loginUserRole != "Admin"
            ? true
            : false,
        cellStyle: { "text-align": "center" },
        cellRendererFramework: editUser,
      },
      {
        headerName: "Delete User",
        field: "",
        width: 100,
        sortable: false,
        hide:
          !this.permissionPageAccessArry.includes(
            PermissionVariables.UserDelete
          ) && this.loginUserRole != "Admin"
            ? true
            : false,

        cellStyle: { "text-align": "center" },
        cellRendererFramework: userStatus,
      },
    ];

    if (this.checkPermission(["Users", "GET"])) {
      this.getUserList(this.currentPage);
    }
    this.gridApi = this.gridOptions.api;
  },
};
</script>
<style>
.img-rounded {
  border-radius: 50%;
  max-width: 40px;
  margin-top: 2px;
  height: 40px;
  object-fit: cover;
  object-position: center;
}
</style>
